import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Badge } from "components/badge/Badge";
import { ICustomer } from "redux/reducers/models/customer";
import { HouseAccountType } from "../../customer/context/contextTypes";

const VISIBLE_CUSTOMER_NAMES = 2;
const TOOLTIP_NAMES_PER_ROW = 2;

function getAccountCustomerNames(account: HouseAccountType): string[] {
  const customers: ICustomer[] =
    account.customers && account.customers.length > 0
      ? account.customers
      : account.customer
        ? [account.customer]
        : [];

  return customers
    .map(customer => customer.full_name?.trim())
    .filter((name): name is string => Boolean(name));
}

function chunkNames(names: string[], size: number): string[][] {
  const rows: string[][] = [];
  for (let index = 0; index < names.length; index += size) {
    rows.push(names.slice(index, index + size));
  }
  return rows;
}

interface IAccountCustomersCellProps {
  account: HouseAccountType;
  visibleCount?: number;
}

export default function AccountCustomersCell(props: IAccountCustomersCellProps) {
  const { account, visibleCount = VISIBLE_CUSTOMER_NAMES } = props;

  const names = getAccountCustomerNames(account);
  const visibleNames = names.slice(0, visibleCount);
  const hiddenNames = names.slice(visibleCount);
  const tooltipRows = chunkNames(hiddenNames, TOOLTIP_NAMES_PER_ROW);

  if (names.length === 0) {
    return null;
  }

  return (
    <div className="account-customers-cell">
      <span className="account-customers-cell__names">
        {visibleNames.join(", ")}
        {hiddenNames.length > 0 ? "," : null}
      </span>
      {hiddenNames.length > 0 ? (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`account-customers-overflow-${account.id}`} className="account-customers-cell__tooltip">
              <div className="account-customers-cell__tooltip-list">
                {tooltipRows.map((row, rowIndex) => (
                  <div key={`tooltip-row-${rowIndex}`}>
                    {row.join(", ")}
                    {rowIndex < tooltipRows.length - 1 ? "," : null}
                  </div>
                ))}
              </div>
            </Tooltip>
          }
        >
          <span className="account-customers-cell__overflow" tabIndex={0}>
            <Badge type="gray" size="xsmall" outline>
              {`+${hiddenNames.length}`}
            </Badge>
          </span>
        </OverlayTrigger>
      ) : null}
    </div>
  );
}
